import moment from "moment";
import { useEffect, useState } from "react";
import { mostraAlertaError, mostraAlertaOk, mostraAlertaPreguntaFacturaccion, mostrarAlertaLoading, cerrarAlerta } from "../../../componentes/alerts/sweetAlert";
import { AxiosImagen } from "../../../componentes/axios/Axios";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import { ComprasGuardar, ComprasListar, CompraFiltro } from "../../../configuracion/apiUrls";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { ErroresPeticion } from "../../../componentes/axios/ErroresPeticion";
import { formatoMoneda } from "../../../configuracion/validaciones";
import MetodosPagoDinamicos from "../../../componentes/metodos/MetodosPagos";

const ModalPago = ({ Total, tipoPago, pago, cajaId, setPago, resetCompra, factura, nuevasImagenes, notaGeneral, limpiarTodo, productosSeleccionados, proveedorId }) => {
    const { Lista, ActualizarLista, listaBancos, setListaComprasFiltradas } = useContextEmpleado();
    const [efectivo, setEfectivo] = useState(0);
    const [totalRecibido, setTotalRecibido] = useState(0)
    const [pos, setPos] = useState(0);
    const [transferencias, setTransferencias] = useState(0);
    const [cambio, setCambio] = useState(0);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [montoCredito, setMontoCredito] = useState('');
    const [fechaPago, setFechaPago] = useState(moment().format('YYYY-MM-DD'));
    const [fechaVencimiento, setFechaVencimiento] = useState('');
    const [montosPos, setMontosPos] = useState({});
    const [referenciasPos, setReferenciasPos] = useState({});
    const [erroresReferenciaPos, setErroresReferenciaPos] = useState({});
    const [montosTransferencia, setMontosTransferencia] = useState({});
    const [referenciasTransferencia, setReferenciasTransferencia] = useState({});
    const [erroresReferenciaTransferencia, setErroresReferenciaTransferencia] = useState({});

    const buscarNumeroFactura = (lista) => {
        var n = 0;
        if (lista.length > 0) {
            lista.forEach(f => {
                n = f.numero
            })
        }
        return n;
    };

    const buscarNumeroRecibo = (lista) => {
        var n = 0;
        if (lista) {
            lista.forEach(f => {
                n = f.id
            })
        }
        return n;
    };

    const buscarNumeroCredito = (lista) => {
        var n = 0;
        if (lista) {
            lista.forEach(f => {
                n = f.id
            }
            )
        }
        return n;
    };

    const accion = (tipos) => {
        const numero =
            tipos === "FA"
                ? buscarNumeroFactura(pago.facturas)
                : tipos === "RE"
                    ? buscarNumeroRecibo(pago.recibos)
                    : buscarNumeroCredito(pago.creditos);
        setPago(prev => ({
            ...prev,
            documento: tipos,
            numero,
            items: factura.items,
        }));
        setDatosPago(prev => ({
            ...prev,
            documento: tipos,
            tipoVenta: tipos === "CR" ? "Crédito" : "Contado"
        }));
        setModalIsOpen(true);
    };

    const ver = () => {
        if (productosSeleccionados.length === 0) {
            mostraAlertaError("Debe seleccionar al menos un producto.", "Error");
            return;
        }
        if (!proveedorId) {
            mostraAlertaError("Debe seleccionar un proveedor.", "Error");
            return;
        }
        mostraAlertaPreguntaFacturaccion(
            (tipo) => {
                accion(tipo);
                setModalIsOpen(true);
            },
            "¿Qué desea generar?"
        );
    };

    const [datosPago, setDatosPago] = useState({
        pago: Total,
        recibido: totalRecibido,
        tipo: tipoPago,
        tipoVenta: 'Contado',
        documento: 'FA',
        efectivo: [
            { monto: 500 }
        ],
        transferencia: [
            { monto: 1000, referencia: "900700027760", cuentaId: 1 }
        ],
        tarjeta: [
            { monto: 700, referencia: "900700027760", posId: 1 }
        ],
        montoCredito: 0,
        fecha: '',
        fechaVencimiento: '',
        saldo: 0,
    });

    useEffect(() => {
    }, [datosPago]);

    useEffect(() => {
    }, [pago]);

    // Este useEffect se gatilla cuando los totales de POS o Transferencias cambian en el subcomponente.
    useEffect(() => {
        const r = parseFloat(pos || 0) + parseFloat(transferencias || 0) + parseFloat(efectivo || 0)
        setTotalRecibido(r);
    }, [pos, transferencias, efectivo]);

    useEffect(() => {
        actualizarListaPagos();
    }, [totalRecibido, montosPos, referenciasPos, montosTransferencia, referenciasTransferencia, datosPago.documento]);

    const actualizarListaPagos = () => {
        let tipoPagoValido = "Efectivo";

        if (totalRecibido > 0) {
            if (parseFloat(efectivo) > 0 && transferencias === 0 && pos === 0) {
                tipoPagoValido = "Efectivo";
            } else if (transferencias > 0 && pos === 0) {
                tipoPagoValido = "Transferencia";
            } else if (pos > 0 && transferencias === 0) {
                tipoPagoValido = "Tarjeta";
            } else {
                tipoPagoValido = "Mixto"; // Si hay mezcla, mejor indicar mixto o el método predominante
            }
        }

        let tipoVenta = "Contado";
        if (datosPago.documento === "CR") {
            tipoVenta = "Crédito";
        }

        let nPago = {
            pago: Total,
            recibido: totalRecibido,
            tipo: tipoPagoValido,
            documento: datosPago.documento,
            tipoVenta: tipoVenta,
            fecha: moment().format("YYYY-MM-DD"),
            efectivo: parseFloat(efectivo) > 0 ? [{ monto: parseFloat(efectivo) }] : [],
        };

        // Transferencias Dinámicas
        const listaTransferencias = Object.keys(montosTransferencia)
            .filter(cuentaId => parseFloat(montosTransferencia[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosTransferencia[cuentaId]),
                referencia: referenciasTransferencia[cuentaId] || "",
                cuentaId: parseInt(cuentaId, 10),
            }));

        if (listaTransferencias.length > 0) {
            nPago = { ...nPago, transferencia: listaTransferencias };
        }

        // Tarjetas (POS) Dinámicas
        const listaPos = Object.keys(montosPos)
            .filter(cuentaId => parseFloat(montosPos[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosPos[cuentaId]),
                referencia: referenciasPos[cuentaId] || "",
                posId: parseInt(cuentaId, 10),
            }));

        if (listaPos.length > 0) {
            nPago = { ...nPago, tarjeta: listaPos };
        }

        setDatosPago(nPago);
    };

    const limpiarDatosPago = () => {
        setEfectivo(0);
        setTotalRecibido(0);
        setPos(0);
        setTransferencias(0);
        setCambio(0);
        setModalIsOpen(false);
        setMontoCredito('');
        setFechaPago(moment().format('YYYY-MM-DD'));
        setFechaVencimiento('');
        setMontosPos({});
        setReferenciasPos({});
        setErroresReferenciaPos({});
        setMontosTransferencia({});
        setReferenciasTransferencia({});
        setErroresReferenciaTransferencia({});
    };

    const GuardarCompras = async () => {
        let hayError = false;

        const obtenerCuentasParaValidacion = (tipo) => {
            return listaBancos.flatMap(banco =>
                banco.cuenta
                    .filter(c => c.tipoCuenta === tipo && c.activo)
                    .map(c => ({
                        id: c.id,
                        digitosMinimos: tipo === 'Pos' ? 6 : 8,
                    }))
            );
        };

        let nuevosErroresPos = {};
        let nuevosErroresTransferencia = {};

        // 1. Validar POS (Referencia debe tener al menos 6 dígitos)
        obtenerCuentasParaValidacion('Pos').forEach(({ id, digitosMinimos }) => {
            const monto = parseFloat(montosPos[id] || 0);
            const referencia = referenciasPos[id] || "";
            const regex = new RegExp(`^\\d{${digitosMinimos},15}$`);

            if (monto > 0 && !regex.test(referencia)) {
                nuevosErroresPos[id] = true;
                hayError = true;
            }
        });
        setErroresReferenciaPos(nuevosErroresPos);

        // 2. Validar Transferencias (Referencia debe tener al menos 8 dígitos)
        obtenerCuentasParaValidacion('Transferencia').forEach(({ id, digitosMinimos }) => {
            const monto = parseFloat(montosTransferencia[id] || 0);
            const referencia = referenciasTransferencia[id] || "";
            const regex = new RegExp(`^\\d{${digitosMinimos},15}$`);

            if (monto > 0 && !regex.test(referencia)) {
                nuevosErroresTransferencia[id] = true;
                hayError = true;
            }
        });
        setErroresReferenciaTransferencia(nuevosErroresTransferencia);

        if (hayError) {
            mostraAlertaError("Hay referencias inválidas. Verifica los campos marcados.", "Error de validación");
            return;
        }

        const esCredito = datosPago.tipoVenta === 'Crédito';
        if (!esCredito) {
            const totalNum = parseFloat(Total);
            const efectivoNum = parseFloat(efectivo);
            const posNum = parseFloat(pos);
            const transferenciaNum = parseFloat(transferencias);
            const totalRecibidoNum = efectivoNum + posNum + transferenciaNum;

            if (totalRecibidoNum <= 0) {
                mostraAlertaError("Debe ingresar al menos un método de pago.", "Error");
                return;
            }
            if (efectivoNum === 0 && totalRecibidoNum !== totalNum) {
                mostraAlertaError("Cuando no hay pago en efectivo, el total de tarjeta y transferencias debe coincidir exactamente con el total de la venta.", "Pago inválido");
                return;
            }
            if (efectivoNum > 0) {
                if ((posNum + transferenciaNum) > totalNum) {
                    mostraAlertaError("La suma de tarjeta y transferencias no puede exceder el total de la venta cuando se paga con efectivo.", "Pago inválido");
                    return;
                }
                const restante = totalNum - (posNum + transferenciaNum);
                if (efectivoNum < restante) {
                    mostraAlertaError("El efectivo ingresado es insuficiente para cubrir el restante de la venta.", "Pago inválido");
                    return;
                }
            }
            if (totalRecibidoNum < totalNum) {
                mostraAlertaError("El total recibido no puede ser menor al total a pagar.", "Error");
                return;
            }
        }
         mostrarAlertaLoading("Guardando compra...", "Esto puede tardar unos segundos");
        const cambioCalculado = esCredito ? 0 : totalRecibido - Total;
        setPago(prev => ({
            ...prev,
            cambio: cambioCalculado,
        }));

        try {
            const formData = new FormData();
            if (nuevasImagenes && nuevasImagenes.length > 0) {
                formData.append('imagen', nuevasImagenes[0].file);
            }

            const compraData = {
                numeroFactura: 1,
                tipoPago: datosPago.tipo,
                tipoVenta: datosPago.tipoVenta,
                fecha: moment().toISOString(),
                estado: "Completada",
                totalCompra: parseFloat(pago.total || 0).toFixed(2),
                empleadoId: parseInt(pago.empleadoId) || 0,
                proveedorId: parseInt(proveedorId) || 0,
                cajaId: cajaId,
                notas: notaGeneral || "Sin notas",
            };

            const compraDetalleData = productosSeleccionados.map(item => ({
                productoId: item.id,
                cantidad: item.cantidad,
                precio: item.precio,
                costo: item.costo,
            }));

            const lotesData = productosSeleccionados.map(item => {
                const costoLote = item.lote?.costo ?? item.costo;
                const precioLote = item.lote?.precio ?? item.precio;
                const utilidadLote = (precioLote - costoLote).toFixed(2);

                return {
                    productoId: item.id,
                    nombre_lote: item.lote?.nombre_lote || `Lote-${item.id}-${moment().format('YYYYMMDDHHmmss')}`,
                    fecha_ingreso: item.lote?.fecha_ingreso || moment().toISOString(),
                    costo: costoLote,
                    precio: precioLote,
                    utilidad: utilidadLote,
                    estado: item.lote?.estado || 'Disponible',
                    cantidad: item.lote?.cantidad || item.cantidad,
                    existencia: item.lote?.existencia || item.cantidad,
                    enPedido: item.lote?.enPedido || 0,
                    lotesPrecios: item.lote?.lotesPrecios || [],
                    lotesInventarios: item.lote?.lotesInventarios || [],
                };
            });

            formData.append('compra', JSON.stringify({ ...compraData, compraDetalle: compraDetalleData }));
            formData.append('lotes', JSON.stringify(lotesData));

            formData.append('pago', JSON.stringify({
                fecha: moment().toISOString(),
                pago: parseFloat(Total).toFixed(2),
                estado: "Completada",
                recibido: esCredito ? 0 : parseFloat(totalRecibido || 0).toFixed(2),
                documento: datosPago.documento,
                cajaId: cajaId,
                efectivo: datosPago.efectivo || [],
                transferencia: datosPago.transferencia || [],
                tarjeta: datosPago.tarjeta || [],
            }));

            formData.append('factura', JSON.stringify({
                numeroFactura: 1,
                fecha: moment().toISOString(),
                estado: "Completada",
                tipoPago: datosPago.tipo,
                total: parseFloat(Total).toFixed(2),
                facturaCaiId: 1,
            }));

            formData.append('recibo', JSON.stringify({
                fecha: moment().toISOString(),
                estado: "Completada",
                tipoPago: datosPago.tipo,
                total: parseFloat(Total).toFixed(2),
            }));

            formData.append('credito', JSON.stringify({
                monto: parseFloat(datosPago.montoCredito || Total).toFixed(2),
                fecha: moment().toISOString(),
                estado: "Pendiente",
                fechaVencimiento: datosPago.fechaVencimiento || moment().add(30, 'days').toISOString(),
                saldo: parseFloat(datosPago.saldo || Total).toFixed(2),
            }));

            await AxiosImagen.post(ComprasGuardar, formData);
            mostraAlertaOk("Compra guardada exitosamente", "Éxito");
            ActualizarLista(CompraFiltro, setListaComprasFiltradas);
            Lista();
            limpiarDatosPago();
            limpiarTodo();
            setModalIsOpen(false);
            setTimeout(() => {
                resetCompra();
            }, 1000);
        } catch (error) {
            ErroresPeticion(error);
        }
    };

    return (
        <ModalBootstrap
            nombreBoton={formatoMoneda(Total) + "  "}
            estiloBoton={"btn btn-info"}
            modalIsOpen={modalIsOpen}
            onTriggerClick={ver}
            size={"lg"}
            setModalIsOpen={setModalIsOpen}
            titulo={`Pagos ${pago.documento === 'FA' ? 'Factura' : pago.documento === 'CR' ? 'Crédito' : 'Recibo'} ${formatoMoneda(Total)}`}
            pie={
                <button
                    className="btn btn-primary mx-2"
                    onClick={() => {
                        setPago(prev => ({ ...prev, cambio, total: Total }));
                        GuardarCompras();
                    }}
                >
                    Pagar
                </button>
            }>
            {pago.documento === 'CR' ? (
                <div className="p-4">
                    <h5 className="mb-4 text-center">Esta venta se registrará a crédito</h5>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label htmlFor="fechaPago" className="form-label">Fecha de pago:</label>
                            <input
                                id="fechaPago"
                                type="date"
                                className="form-control"
                                value={fechaPago}
                                onChange={e => setFechaPago(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="fechaVencimiento" className="form-label">Fecha de vencimiento:</label>
                            <input
                                id="fechaVencimiento"
                                type="date"
                                className="form-control"
                                value={fechaVencimiento}
                                onChange={e => {
                                    const valor = e.target.value;
                                    setFechaVencimiento(valor);
                                    setDatosPago(prev => ({
                                        ...prev,
                                        fechaVencimiento: valor
                                    }));
                                }}
                            />
                        </div>
                    </div>
                </div>
            ) : (
                    <MetodosPagoDinamicos
                        esCompra={true}
                        efectivo={efectivo}
                        setEfectivo={setEfectivo}
                        montosPos={montosPos}
                        setMontosPos={setMontosPos}
                        referenciasPos={referenciasPos}
                        setReferenciasPos={setReferenciasPos}
                        erroresReferenciaPos={erroresReferenciaPos}
                        setErroresReferenciaPos={setErroresReferenciaPos}
                        montosTransferencia={montosTransferencia}
                        setMontosTransferencia={setMontosTransferencia}
                        referenciasTransferencia={referenciasTransferencia}
                        setReferenciasTransferencia={setReferenciasTransferencia}
                        erroresReferenciaTransferencia={erroresReferenciaTransferencia}
                        setErroresReferenciaTransferencia={setErroresReferenciaTransferencia}
                        pos={pos}
                        setPos={setPos}
                        transferencias={transferencias}
                        setTransferencias={setTransferencias}
                        formatoMoneda={formatoMoneda}
                        totalConRecargo={Total}
                        totalRecibido={totalRecibido}
                    />
            )}
        </ModalBootstrap>
    );
}
export default ModalPago;
